import apiClient from '../client';
import $U from '../urls';

export const addGift = giftNote => {
  const data = {
    note: giftNote,
  };

  return apiClient.request('POST', $U.GIFT_ADD, data);
}

export const removeGift = () => {
  return apiClient.request('POST', $U.GIFT_REMOVE);
};